module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/check-thin-437efa02edea99b8d9efb0d03abf59dc.svg";